import { useContext, useEffect, useState } from 'react';
import { FeatureInfoContext } from "../components/FeatureInfoContext";
import { useGeoApps } from "@mapgear/geoapps-ui-framework";
import { FeatureInfoType } from "../types/FeatureInfoType";

export const useHighlightLayer = () => {
    const { geoapps } = useGeoApps();
    const map = geoapps.GetMap("map");
    const { setYears, highlightLayer } = useContext(FeatureInfoContext);

    /**
   * Adds marker on the map of the selected feature
   * @param featureInfo The feature info

   */
    const goToSelected = (featureInfo: FeatureInfoType) => {
        if (!featureInfo.geom || !featureInfo.nr) return;

        const coords = JSON.parse(featureInfo.geom).coordinates;
        zoomTo(coords);
        addFeatureToHighlightLayer(featureInfo.geom, featureInfo.nr);
        setYears?.([featureInfo.from, featureInfo.until]);
    };

    /**
     * Zooms to a selected feature
     * @param coords Coordinates to zoom to
     */
    const zoomTo = (coords: [number, number]) => {
        const zoomTo = {
            X: coords[0],
            Y: coords[1],
            Zoom: 17,
            Rotation: 0
        }

        map.ZoomTo(zoomTo);
    };

    /**
     * Adds a feature to the highlightlayer
     * @param geom The info of this feature
     * @param nr Number or id of plot
     * @param highlightLayer The highlightlayer
     */
    const addFeatureToHighlightLayer = (geom: string, nr: string) => {
        if (!highlightLayer) return;

        clearFeatures();
        // Set style for the layer
        const iconStyle = {
            icon: {
                image: "~/resources/icons/icon.png",
                anchor: [0.5, 1],
                scale: 1.3
            },
            text: {
                text: nr,
                font: "bold 15px sans-serif",
                offset: [40, -35],
                backgroundFill: {
                    color: "#00ff00",
                }
            }
        };

        // Set style and add feature
        highlightLayer.SetStyle(iconStyle);
        highlightLayer.AddFeature(geom);
    };

    /**
     * Clears the features of the highlight layer.
     */
    const clearFeatures = () => {
        highlightLayer.ClearFeatures();
    };

    return {
        goToSelected,
        clearFeatures,
    }
};
